var render = function render(){var _vm=this,_c=_vm._self._c;return _c('coverage-template',{attrs:{"gender":_vm.gender,"facial-acne-coverage":_vm.facialAcneCoverage,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }